import { useEffect } from 'react';

export interface ToastProps {
  open: boolean;
  kind?: 'success' | 'error' | 'warning';
  message: string;
  retryLabel?: string;
  duration?: number;
  onRetry?: () => void;
  onClose: () => void;
}

export function Toast({
  open,
  kind = 'success',
  message,
  retryLabel = 'Thử lại',
  duration = 4000,
  onRetry,
  onClose,
}: ToastProps) {
  useEffect(() => {
    if (!open || duration <= 0) return;
    const timer = window.setTimeout(onClose, duration);
    return () => window.clearTimeout(timer);
  }, [duration, onClose, open]);

  if (!open) return null;
  return (
    <div className={`toast toast--${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      <span className="toast__icon" aria-hidden={true}>{kind === 'success' ? '✓' : kind === 'warning' ? '⚠' : '!'}</span>
      <span className="toast__message">{message}</span>
      {onRetry ? <button type="button" className="toast__retry" onClick={onRetry}>{retryLabel}</button> : null}
      <button type="button" className="toast__close" aria-label="Đóng thông báo" onClick={onClose}>×</button>
    </div>
  );
}

export default Toast;
